import { USER_STATE } from './constants'

export interface UserState {
  [USER_STATE]: {
    error: string | null
    isFetching: boolean
    isPasswordChanged: boolean | null
    isUserCreated: boolean | null
    isUserUpdated: boolean | null
    creditCard: {
      brand: string
      expiryDate: string
      holder: string
      number: string
    } | null
  }
}

const state: UserState = {
  [USER_STATE]: {
    error: null,
    isFetching: false,
    isPasswordChanged: null,
    isUserCreated: null,
    isUserUpdated: null,
    creditCard: null,
  },
}

export default state
